import PropTypes from 'prop-types';
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';

const CardSkeleton = ({ count }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
        gap: 2,
        margin: 3,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index} sx={{ borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <CardContent>
            <Stack spacing={2}>
              {/* Title */}
              <Skeleton variant="text" width="60%" height={32} />

              {/* Drives count */}
              <Skeleton variant="text" width="40%" height={20} />

              {/* Description line */}
              <Stack direction="row" spacing={1}>
                <Skeleton variant="text" width="20%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>

              {/* Company line */}
              <Stack direction="row" spacing={1}>
                <Skeleton variant="text" width="20%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>

              {/* Created by line */}
              <Stack direction="row" spacing={1}>
                <Skeleton variant="text" width="20%" height={20} />
                <Skeleton variant="text" width="50%" height={20} />
              </Stack>

              {/* Buttons */}
              <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>
                <Skeleton variant="rounded" width="45%" height={40} />
                <Skeleton variant="rounded" width="45%" height={40} />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

CardSkeleton.propTypes = {
  count: PropTypes.number.isRequired,
};

export default CardSkeleton;
